import { ReactElement } from 'react';

export enum FilterTrackingElement {
  FilterApplied = 'Filter applied (Filter card)',
  FilterDeleted = 'Filter deleted (Filter card)',
  SharedFilterApplied = 'Shared filter applied (Filter card)',
  SharedFilterDeleted = 'Shared filter deleted (Filter card)',
  ShareFilter = 'Share filter (Filter card)',
  ShareFilterModal = 'Share filter (Share filter modal)',
}

export interface TrackingTags {
  access?: string;
  elementCategory?: string;
}

export interface ActionTrackingTags extends TrackingTags {
  elementName: string;
}

export interface ButtonProps<T extends ActionTrackingTags = ActionTrackingTags> {
  disabled?: boolean;
  testId?: string;
  getTrackingTags?: () => T;
  onClick: () => void;
}

export interface FilterActionProps extends ButtonProps {
  children: ReactElement;
  className?: string;
  label: string;
}
